import router from '@/router/router'

router.beforeEach(async (to, from, next) => {
	next();
})








